import { render, staticRenderFns } from "./SectorMethodology.vue?vue&type=template&id=df47bfec&"
import script from "./SectorMethodology.vue?vue&type=script&lang=js&"
export * from "./SectorMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports